export default __webpack_public_path__ + "static/media/noLearningOutcomes.0bc952eb.svg";